import React, { Component } from 'react';
import _ from 'lodash';
var Api = require('./Config');

export default class JourneyChooser extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: '', orgiJourneys: [] };
    this.state.journeys = [];
  }

  componentDidMount() {
    Api.getJourneyMaster(Api.EXCLUDED_JIDS)
      .then((journeys) => {
        if (this.props.RMG !== true) {
          _.remove(journeys, (a) => a.JID == 12);
        }

        if (this.props.MGDEMO !== true) {
          _.remove(journeys, (a) => a.JID == 5);
        }

        if (this.props.MGDEMO !== true && this.props.TEST !== true && this.props.RMG !== true) {
          _.remove(journeys, (a) => a.JID == 18);
        }

        if (
          this.props.MGDEMO !== true &&
          this.props.TEST !== true &&
          this.props.RMG !== true &&
          this.props.CAAIHS !== true
        ) {
          _.remove(journeys, (a) => a.JID == 17);
        }

        if (this.props.RTTEST !== true) {
          _.remove(journeys, (a) => a.category == 'REF');
          _.remove(journeys, (a) => a.category == 'NAN');
        }

        if (this.props.vasentara !== true) {
          _.remove(journeys, (a) => a.JID == 13);
        }

        if (this.props.WCCHC == true) {
          const includeJids = [1, 20, 10, 21];
          _.remove(journeys, (a) => {
            return !includeJids.includes(parseInt(a.JID));
          });
        }

        if (this.props.VAHEALS === true) {
          _.remove(journeys, (a) => a.JID == 3);
          _.remove(journeys, (a) => a.JID == 10);
        }

        if (this.props.CAWATTS === true) {
          _.remove(journeys, (a) => a.JID == 3);
          _.remove(journeys, (a) => a.JID == 26);
        }

        if (this.props.PACONS === true) {
          _.remove(journeys, (a) => a.JID == 25);
          _.remove(journeys, (a) => a.JID == 28);
        }

        if (this.props.CAAIHS === true) {
          _.remove(journeys, (a) => a.JID == 16);
        }

        if (this.props.CAPEACH === true) {
          _.remove(journeys, (a) => a.JID == 30);
        }

        if (this.props.DEPPHQ8 !== true) {
          _.remove(journeys, (a) => a.JID == 31);
        }

        if (this.props.RTCLONES !== true) {
          _.remove(journeys, (a) => a.JID == 32);
          _.remove(journeys, (a) => a.JID == 33);
          _.remove(journeys, (a) => a.JID == 34);
          _.remove(journeys, (a) => a.JID == 35);
          _.remove(journeys, (a) => a.JID == 36);
          _.remove(journeys, (a) => a.JID == 37);
          _.remove(journeys, (a) => a.JID == 38);
          _.remove(journeys, (a) => a.JID == 39);
        }

        if (this.props.CATEGORYBASED && Array.isArray(this.props.CATEGORYBASED)) {
          _.remove(journeys, (a) => !this.props.CATEGORYBASED.includes(a.category));
        }

        this.setState({ journeys: journeys, orgiJourneys: journeys });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  doFilter() {
    this.state.journeys = _.filter(this.state.orgiJourneys, (data) => {
      return data.journey_name.toLowerCase().indexOf(this.state.filter.toLowerCase()) != -1;
    });
  }

  render() {
    return (
      <div className="modal show">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.props.onClose();
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <h4 className="modal-title">Select Journey</h4>
            </div>
            <div className="modal-body">
              <div>
                <input
                  value={this.state.filter}
                  onChange={(e) => {
                    this.state.filter = e.target.value;
                    this.setState({ filter: e.target.value });
                    this.doFilter();
                  }}
                  type="text"
                  className="form-control"
                  placeholder="search"
                />
              </div>
              <div style={{ maxHeight: 400, overflow: 'auto' }}>
                <table className="table table-stripped">
                  <tbody>
                    <tr>
                      <td>
                        <b>Journeys</b>
                      </td>
                    </tr>
                    {_.map(this.state.journeys, (a, index) => {
                      return (
                        <tr key={index}>
                          <td
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.props.onSelect(a);
                            }}
                          >
                            {a.journey_name}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  this.props.onClose();
                }}
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
